import { DEFAULT_PATHS } from "core/constants/app-paths"

// Use default paths from core since they match exactly
export const {
  HOME_PATH,
  ABOUT_US_PATH,
  CONTACT_US_PATH,
  TERMS_PATH,
  PRIVACY_POLICY_PATH,
  // Export paths that core needs
  LOGIN_PATH,
  PROJECTS_PATH,
  DASHBOARD_PATH,
  PROFILE_PATH,
  CLIENTS_PATH,
  INVENTORY_PATH,
  LEADS_PATH,
  RESET_PASSWORD_PATH,
  FAQ_PATH,
} = DEFAULT_PATHS

export const NAME_SPACE = ["ar", "en"]
